import {action, extendObservable} from 'mobx';
import {FETCH_URL} from "../constants/ServerLinks";

class Policies {

    constructor({policies = []}, cityId) {
        extendObservable(this, policies);
        this.apiUrl = FETCH_URL + '/api/v1/policies/?city_id=' + cityId.toString();
    }

    @action
    fetchPolicies = async () => {
        const response = await fetch(`${this.apiUrl}`);
        const db_policies = await response.json();
        console.log("From Store/Policies: " + JSON.stringify(db_policies.data))
        this.policies = db_policies.data;
    };

}

export default Policies;
